import React from 'react'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { mobile } from '@/utils/media'
import { mq } from '@/utils/helpers'
import Subtitle from '@/components/common/Subtitle'
import Typography from '@/components/common/Typography'

const Section = props => {
  const { subtitle, title, body, subTitleProps, titleProps, bodyProps, styles = {}, children, ...others } = props
  return (
    <Root {...others} css={styles.root ? styles.root : undefined}>
      {subtitle && (
        <Subtitle
          variant="h5"
          component="h2"
          {...subTitleProps}
          color="primary">{subtitle}
        </Subtitle>
      )}
      <Main css={styles.main ? styles.main : undefined}>
        {title && (
          <Title
            variant="h2"
            component="h3"
            {...titleProps}
            css={styles.title ? styles.title : undefined}>
            {title}
          </Title>
        )}
        {body && (
          <Body
            variant="body1"
            {...bodyProps}
            css={styles.body ? styles.body : undefined}>
            {body}
          </Body>
        )}
        {children && (
          <Children hasTitle={Boolean(title)}>{children}</Children>
        )}
      </Main>
    </Root>
  )
}

export default ThemeConsumer(Section)

const Root = styled.div`
`

const Main = styled.div`
`

const Title = styled(Typography)`
  margin-top: 16px;
`

const Body = styled(Typography)`
  margin-top: 34px;
`

const Children = styled.div`
  margin-top: ${props => props.hasTitle
    ? '42px'
    : '16px'
  };
  @media ${mq.and(mobile)} {
    margin-top: 24px;
  }
`
